import { combineReducers } from "redux";

import menuAuthorizationDocumentSlice from "./menu";
import fromSearchAuthorizationDocumentSlice from "./formSearch";
import getDetailSlice from "./getDetail";
import getListAuthorizationDocsSlice from "./getListAuthorizationDocs";

const authorizationDocumentReducer = combineReducers({
  menuAuthorizationDocumentSlice,
  fromSearchAuthorizationDocumentSlice,
  getDetailSlice,
  getListAuthorizationDocsSlice,
});

export default authorizationDocumentReducer;
